/**
 * BWS SC Angular Service.
 *
 * NOTE: Invokes the bws.js script.
 */
class StackchatService {
    constructor($state, $document, settingsService) {
        function gotoState(statename, parameters) {
            $state.go(statename, parameters);
        }

        function dynamicallyLoadScript(url) {
            const script = $document[0].createElement('script'); // Make a script DOM node
            script.src = url; // Set it's src to the provided URL
            $document[0].head.appendChild(script); // Add it to the end of the head section of the page (could change 'head' to 'body' to add it to the end of the body section instead)
        }

        function handleEvent(pageUpdateEvent) {
            gotoState(pageUpdateEvent.detail.routeName, pageUpdateEvent.detail.routeParameters);
        }

        this.initialise = () => {
            const isCheckout = window.location.pathname.indexOf('/checkout') > -1;

            settingsService.getSettingValue('StackChat', 'StackChatVersion').then(function (version) {
                let versionNumber = '0';
                if (version) {
                    versionNumber = version;
                }
                const init = () => {
                    dynamicallyLoadScript('https://cdn.bws.au.stackchat.com/bws/bws.js?cb=' + versionNumber);
                    // Handles page redirection when the web-messenger needs to open a search query param url.
                    $document[0].addEventListener('Web-messenger-page-redirect', handleEvent, false);
                };

                // Inject the stackchat web-messenger block to the page.
                if (!isCheckout) {
                    init();
                }
            });
        };
    }
}

module.exports = StackchatService;


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/stackchat/stackchat-service.js
 **/